import LandingNav from "../../landing-page/components/LandingNav";
import Footer from "../../landing-page/components/Footer";
import { footerNavigation } from "../../landing-page/contentSections";
import { Button } from "../../components/ui/button";

export const ContactPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <LandingNav />
      <main className="flex-grow pt-32 pb-16 px-6 lg:px-8 max-w-4xl mx-auto w-full text-center">
        <h1 className="text-4xl font-bold mb-8">Contact Us</h1>
        <div className="space-y-8 text-muted-foreground leading-relaxed">
          <p className="text-xl">
            Have questions or need support? We're here to help you simplify your student life.
          </p>
          
          <div className="p-8 rounded-3xl bg-primary/5 border border-primary/10 inline-block">
            <h2 className="text-2xl font-semibold text-foreground mb-4">Email Us</h2>
            <p className="text-lg text-primary font-medium mb-6">support@gedoba.com</p>
            <Button size="lg" className="rounded-full px-10" asChild>
              <a href="mailto:support@gedoba.com">Send Message</a>
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 text-left">
            <div className="p-6 rounded-2xl border border-border/50">
              <h3 className="font-semibold text-foreground mb-2">Office Hours</h3>
              <p>Monday - Friday: 9am - 5pm EST</p>
              <p>Response time: Within 24 hours</p>
            </div>
            <div className="p-6 rounded-2xl border border-border/50">
              <h3 className="font-semibold text-foreground mb-2">Address</h3>
              <p>123 University Ave</p>
              <p>Campus Tech Hub, Level 2</p>
            </div>
          </div>
        </div>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
};
